import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Desktop",
  "use": "Desktop-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"Desktop\"><path d=\"M27.5 3.2h-23C3.1 3.2 2 4.3 2 5.7v15.4c0 1.4 1.1 2.6 2.5 2.6h8.9v2.6h-2.5v2.6h10.2v-2.6h-2.5v-2.6h8.9c1.4 0 2.5-1.1 2.5-2.6V5.7c0-1.4-1.1-2.5-2.5-2.5zm0 17.9h-23V5.7h22.9v15.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol